import { useMutation, useQueryClient } from "@tanstack/react-query";
import API from "@/api";

type TMutationFn = {
  onSuccess: () => void;
}

function useDeleteObservation(nurseryId: string, rackId: string, observationId: string) {
  const queryClient = useQueryClient();
  const { mutate, isPending, error } = useMutation({
    mutationFn: ({ onSuccess }: TMutationFn) => API.deleteObservation(nurseryId, observationId).then(onSuccess),
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ["observation", nurseryId, observationId], exact: true });
      queryClient.invalidateQueries({ queryKey: ["rack-observations", nurseryId, rackId], exact: true });
    },
  });

  return {
    deleteObservation: mutate,
    deleteIsPending: isPending,
    deleteError: error
  };
}

export default useDeleteObservation;
